(function () {
    if (document.querySelectorAll(".js-slider").length > 0) {

        const slider = {
            props: {
                infiniteScroll: false
            },
            init: () => {
                const sliders = document.querySelectorAll(".js-slider");

                if (window.screen.width >= 1048) return;

                sliders.forEach((slide) => {
                    slider.detectSwipe(slide);
                });
            },
            detectSwipe: (el) => {
                const detect = {
                    startX: 0,
                    endX: 0,
                    minX: 50,
                    maxX: 50
                };
                let direction = null;

                el.addEventListener('touchstart', (event) => {
                    event.preventDefault();
                    const touch = event.touches[0];
                    detect.startX = touch.screenX;
                });

                el.addEventListener('touchmove', (event) => {
                    event.preventDefault();
                    const touch = event.touches[0];
                    detect.endX = touch.screenX;
                });

                el.addEventListener('touchend', (event) => {
                    event.preventDefault();
                    if (detect.endX === 0) return;

                    if ((Math.abs(detect.endX - detect.startX) > detect.minX)) {
                        direction = (detect.endX > detect.startX) ? 'right' : 'left';

                        slider.changeSlide(direction, el);
                    }

                    detect.endX = 0;
                });
            },
            changeSlide: (dir, element) => {
                let sliderIndex = parseInt(getComputedStyle(element).getPropertyValue("--slider__index"));
                const slidesAmount = parseInt(element.dataset.slides) - 1;
                const dots = element.querySelectorAll(".slider__dot");
                const currentDot = element.querySelector(".slider__dot--active");

                if (dir === "left") {
                    if (sliderIndex < slidesAmount) {
                        sliderIndex = sliderIndex + 1;

                    }
                    else {
                        if (slider.props.infiniteScroll) {
                            sliderIndex = 0;
                        }
                    }

                    element.style.setProperty("--slider__index", sliderIndex);
                }

                if (dir === "right") {
                    if (sliderIndex > 0) {
                        sliderIndex = sliderIndex - 1;
                    }
                    else {
                        if (slider.props.infiniteScroll) {
                            sliderIndex = slidesAmount;
                        }
                    }

                    element.style.setProperty("--slider__index", sliderIndex);
                }

                if (dots.length > 0) {
                    currentDot.classList.remove("slider__dot--active");
                    dots[sliderIndex].classList.add("slider__dot--active");
                }
            }
        };

        slider.init();
    }
})();
